<template>
	<div class="message">
		{{ message }}
		<button class="button close" @click="$emit('close')"></button>
	</div>
</template>

<script>
	export default {
		props : ['message']
	}
</script>

<style lang="scss" scoped>
	@import "../../assets/scss/var";

	.message {
		background : transparentize($color-black, 0.2);
		box-sizing : border-box;
		color      : $color-red;
		padding    : $gap-large 40px /*horizonal space for 'X' button*/;
		position   : fixed;
		top        : 0;
		width      : 100%;
		z-index    : 2;
	}

	.close {
		position : fixed;
		top      : $gap-large;
		right    : $gap-large;
	}

</style>
